import React from 'react'

const Timer = ({min, secDis}) =>{
    return(
        <div className="timer-string">{min}:{secDis}</div>
    )
  }

export default Timer